// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 337) return "js/337-1f7d5accf8e6028963c5.js";
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "8ab995292eebb413f414" + ".chunk.js";
};